import React from 'react';
import { Input, Radio, Button, Space } from 'antd';

const { Search } = Input;

const UserFilters = ({ onSearch, onFilterChange, onRefresh, loading }) => {
  return (
    <Space align="center" wrap>
      <Search
        placeholder="Search users..."
        onSearch={onSearch}
        onChange={(e) => onSearch(e.target.value)}
        allowClear
      />

      <Radio.Group onChange={onFilterChange} defaultValue="all">
        <Radio.Button value="all">All</Radio.Button>
        <Radio.Button value="verified">Verified</Radio.Button>
        <Radio.Button value="unverified">Unverified</Radio.Button>
        <Radio.Button value="active">Active</Radio.Button>
        <Radio.Button value="inactive">Inactive</Radio.Button>
      </Radio.Group>

      <Button type="primary" onClick={onRefresh} loading={loading}>
        Refresh
      </Button>
    </Space>
  );
};

export default UserFilters;
